// Profile.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../components/Firebase";
import { toast, ToastContainer } from "react-toastify";
import useUserData from "../hooks/useUserData";
import { AlertCircle, ArrowLeft, ChevronRightCircle, Eraser, Lock, LogOut, PackageCheck, Phone, ReceiptText } from "lucide-react";

const Profile = () => {
  const navigate = useNavigate();
  const userData = useUserData();
  const [fullProfile, setFullProfile] = useState(false);

  const handleSignOut = async () => {
    try {
      await auth.signOut();
      navigate("/register");
    } catch (error) {
      toast.error(`Error: ${error.message}`, { position: "top-center" });
    }
  };

  if (!userData) return ; // Show shimmer while loading

  return (
    <div className="relative z-10">
      {fullProfile ? (
        <div className="">
          <div className="relative  flex items-center flex-col w-[220px] h-[70px] bg-white rounded-lg mb-3 p-2">
            <ArrowLeft className=" absolute left-0 top-2 text-xl  cursor-pointer hover:bg-slate-100/60 w-10 h-10 p-2  rounded-full" onClick={() => setFullProfile(false)} />
            <img
              src="https://wallpapers.com/images/high/netflix-profile-pictures-5yup5hd2i60x7ew3.webp"
              alt="profile picture"
              className="w-9 h-9 rounded-sm cursor-pointer"
            ></img>
            <p className="flex gap-2 mt-1 font-semibold">{userData.username} <Eraser className="fill-yellow-600/80 text-white w-6 h-6 "/></p>
            
          </div>
          <div className="absolute bg-white rounded-lg w-[220px] ">
            <p className="flex  pb-5 cursor-pointer items-center justify-center text-left p-2 hover:bg-slate-100/60"><PackageCheck className="fill-yellow-600/80 text-white w-6 h-6"/> My orders <ChevronRightCircle className="fill-gray-500 text-white w-6 h-6 ml-auto "/></p>
            <p className="flex  pb-5 cursor-pointer items-center justify-center text-left p-2 hover:bg-slate-100/60"><Lock className="fill-yellow-600/80 text-white w-6 h-6"/> Change Password <ChevronRightCircle className="fill-gray-500 text-white w-6 h-6 ml-auto"/></p>
            <p className="flex  pb-5 cursor-pointer items-center justify-center text-left p-2 hover:bg-slate-100/60"><ReceiptText className="fill-yellow-600/80 text-white w-6 h-6"/> Terms and Conditions <ChevronRightCircle className="fill-gray-500 text-white w-6 h-6 ml-auto"/></p>
            <p className="flex  pb-5 cursor-pointer items-center justify-center text-left p-2 hover:bg-slate-100/60"><AlertCircle className="fill-yellow-600/80 text-white w-6 h-6"/>About Us <ChevronRightCircle className="fill-gray-500 text-white w-6 h-6 ml-auto"/></p>
            <p className="flex  pb-5 cursor-pointer items-center justify-center text-left p-2 hover:bg-slate-100/60"><Phone className="fill-yellow-600/80 text-white w-6 h-6"/>Contact Us <ChevronRightCircle className="fill-gray-500 text-white w-6 h-6 ml-auto"/></p>
            <button className="flex  mb-5 cursor-pointer items-center text-left rounded-lg p-2 w-[100%] bg-red-500/70 hover:bg-red-700/70" onClick={handleSignOut}><LogOut className="fill-white text-white w-6 h-6"/>Logout <ChevronRightCircle className="fill-gray-500 text-white/70 w-6 h-6 ml-auto"/> </button>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <p className="font-semibold">Welcome, {userData.username || "User"}</p>
          <img
            src="https://wallpapers.com/images/high/netflix-profile-pictures-5yup5hd2i60x7ew3.webp"
            alt="Acc Icon"
            className="w-12 h-12 rounded-sm cursor-pointer"
            onClick={() => setFullProfile(true)}
          />
        </div>
      )}
      <ToastContainer position="top-center" />
    </div>
  );
};

export default Profile;
